import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import { TermsContext } from '../App';
import Check from '@images/svg/ui/check.svg';

const AcceptTerms = ({ accepted, setAccepted }) => {
  const termsModalRef = useContext(TermsContext);
  const openTerms = event => {
    event.stopPropagation();
    event.preventDefault();
    termsModalRef.current?.open();
  };
  return (
    <div className='c-accept-terms'>
      <Button onClick={openTerms} label='Teilnahmebedingungen lesen' />

      <input
        className='c-accept-terms__checkbox-input'
        type='checkbox'
        id='agreeTerms'
        checked={accepted}
        onChange={e => setAccepted(e.target.checked)}
      />
      <label htmlFor='agreeTerms' className='c-accept-terms__checkbox'>
        <div className='c-accept-terms__check'>
          <Check />
        </div>
        <span>Ich stimme den Bedingungen zu.</span>
      </label>
    </div>
  );
};

AcceptTerms.propTypes = {
  accepted: PropTypes.bool,
  setAccepted: PropTypes.func
};

export default AcceptTerms;
